// Guide passo-passo per ogni schermata — IT + EN (ES/FR/DE in helpGuides.intl.js)
export const GUIDES_IT = {
  dashboard: [
    "Apri la Dashboard per vedere a colpo d'occhio ordini, produzione e incassi del giorno.",
    "Tocca una card di riepilogo per saltare alla sezione corrispondente.",
    "Usa la ricerca globale in alto per trovare subito prodotti, clienti o pagine.",
    "Controlla gli avvisi e i numeri in rosso: indicano cose da gestire oggi.",
    "Apri il menu laterale per raggiungere tutte le sezioni di Chef Control.",
  ],
  cassa: [
    "Tocca i prodotti del catalogo per aggiungerli allo scontrino.",
    "Correggi le quantità toccando la riga nello scontrino.",
    "Premi Incassa e scegli contanti o carta per chiudere il conto.",
    "Usa il tasto Fine giornata per contare la cassa e chiudere il turno.",
    "Consulta i totali del giorno per verificare gli incassi.",
    "Gestisci i prodotti rapidi dal gestore prodotti della cassa.",
  ],
  prenotazioni: [
    "Crea una nuova prenotazione con nome, data e numero di persone.",
    "Scegli il tavolo e l'orario per evitare sovrapposizioni.",
    "Conferma o disdici una prenotazione toccandola nella lista.",
    "Usa il calendario per spostarti tra i giorni.",
    "Stampa o condividi il QR per far prenotare i clienti da soli.",
  ],
  orders: [
    "Controlla gli ordini in attesa e tocca Approva per confermarli.",
    "Filtra per reparto (pasticceria, panificazione, panettoni) con i filtri in alto.",
    "Apri un ordine per vedere prodotti, quantità e note del cliente.",
    "Segna Evaso quando l'ordine è pronto e consegnato.",
    "Stampa bolla o fattura direttamente dall'ordine.",
    "Usa la barra di ricerca per trovare un ordine per cliente o prodotto.",
    "I giorni sono raggruppati a scomparsa: tocca la data per aprirli.",
  ],
  production: [
    "Apri Produzione per vedere cosa preparare oggi, reparto per reparto.",
    "Tocca un prodotto per vedere i clienti che lo hanno ordinato.",
    "Stampa il foglio di produzione per il laboratorio.",
    "Usa il calendario per preparare in anticipo i giorni successivi.",
    "Spunta le righe completate per tenere traccia dell'avanzamento.",
  ],
  partners: [
    "Aggiungi un cliente con nome, contatti e dati fiscali.",
    "Apri la scheda cliente per listino, sconti e prezzi netti dedicati.",
    "Genera il codice portale e invialo al cliente per fargli ordinare da solo.",
    "Consulta ordini, documenti e avanzi del cliente dalla sua scheda.",
    "Usa la ricerca per trovare subito un cliente.",
  ],
  suppliers: [
    "Aggiungi un fornitore con nome e contatti.",
    "Genera il codice portale fornitore per inviargli richieste e messaggi.",
    "Invia richieste di riordino direttamente dalla scheda fornitore.",
    "Carica le fatture del fornitore per aggiornare i costi di acquisto.",
    "Controlla lo storico degli acquisti per confrontare i prezzi.",
  ],
  caldane: [
    "Crea una caldana con i prodotti fissi e i giorni della settimana.",
    "Condividi il codice caldane con il punto vendita per la conferma.",
    "Controlla le caldane generate oggi nell'elenco dedicato.",
    "Modifica quantità o prodotti in qualsiasi momento.",
    "Le bolle vengono generate automaticamente nei giorni scelti.",
  ],
  ricorrenti: [
    "Crea un ordine ricorrente scegliendo cliente, prodotti e giorni della settimana.",
    "L'ordine viene generato da solo nei giorni impostati e arriva negli Ordini.",
    "Usa Invia negli ordini per generare subito la bolla di oggi.",
    "Gli ordini misti vengono divisi automaticamente tra pasticceria e panificazione.",
    "Metti in pausa o elimina un ricorrente quando non serve più.",
  ],
  torte: [
    "Crea un ordine torta con cliente, data di consegna e dettagli.",
    "Scegli farcitura, forma, dimensione e scritta sulla torta.",
    "Aggiungi accessori come candeline o decorazioni.",
    "Stampa la scheda torta con gli allergeni da consegnare con la torta.",
    "Controlla il calendario delle torte per organizzare la produzione.",
  ],
  panettoni: [
    "Aggiungi i panettoni al catalogo con nome, prezzo e foto.",
    "I clienti vedono la scheda Panettoni nel loro portale e ordinano da lì.",
    "Gli ordini arrivano in questa pagina: approvali e segnali evasi.",
    "Usa la ricerca per trovare un panettone nel catalogo.",
    "Imposta la suoneria dedicata per sapere subito quando arriva un ordine.",
  ],
  avanzi: [
    "Apri il foglio avanzi del giorno per ogni cliente o reparto.",
    "Il comprato si riempie da solo dagli ordini della giornata.",
    "Il cliente compila solo la quantità avanzata su ogni riga.",
    "Usa il calendario per compilare o correggere i giorni passati.",
    "Il valore degli avanzi confluisce automaticamente nel registro sprechi.",
  ],
  waste: [
    "Registra uno spreco scegliendo prodotto, quantità e motivo.",
    "Controlla la perdita totale: sprechi diretti più avanzi dei clienti.",
    "Apri il riepilogo mese per mese per capire dove tagliare.",
    "Usa la ricerca per trovare uno spreco registrato.",
    "Elimina una riga errata con il cestino.",
  ],
  preventivi: [
    "Crea un preventivo scegliendo cliente e prodotti dal catalogo.",
    "Imposta il prezzo concordato: prevale sul listino.",
    "Condividi il preventivo con il cliente per la conferma.",
    "Converti il preventivo in ordine con un tocco.",
    "Passa tra listino ingrosso e pubblico per ricalcolare i prezzi.",
  ],
  b2b: [
    "Genera il tuo codice di collegamento B2B dalla pagina.",
    "Inserisci il codice dell'altra azienda per collegarvi.",
    "Approva la richiesta di collegamento per creare il canale.",
    "Invia ordini all'azienda collegata direttamente da qui.",
    "Gli ordini ricevuti appaiono speculari nelle due aziende.",
  ],
  messages: [
    "Scegli un cliente o fornitore per aprire la conversazione.",
    "Scrivi il messaggio e invia: arriva sul suo portale.",
    "Allega foto o documenti quando serve.",
    "Le risposte arrivano qui con l'avviso sonoro se attivo.",
    "Usa la ricerca per ritrovare una conversazione.",
  ],
  recipes: [
    "Crea una ricetta con nome, categoria e reparto.",
    "Aggiungi la foto dalla fotocamera o dalla galleria di Chef Control.",
    "Imposta prezzo di vendita e visibilità nel catalogo.",
    "Segna gli allergeni: verranno stampati su bolle e schede.",
    "Apri la ricetta per modificarla o archiviarla.",
  ],
  formula: [
    "Apri una ricetta del ricettario per vedere ingredienti e percentuali.",
    "Sblocca il lucchetto per modificare pesi e ingredienti.",
    "Imposta pezzi e grammatura: tutte le dosi si ricalcolano da sole.",
    "Usa le sezioni (lievito madre, impasti, glassa) per i grandi lievitati.",
    "Collega gli ingredienti al magazzino per scaricare le scorte producendo.",
    "Stampa il foglio di lavoro per il laboratorio.",
  ],
  lab: [
    "Apri il Laboratorio per pianificare le produzioni del giorno.",
    "Scegli la ricetta e i pezzi da produrre.",
    "Conferma la produzione per scaricare gli ingredienti dal magazzino.",
    "Stampa le etichette con lotto e scadenza.",
    "Controlla lo storico produzioni per la tracciabilità.",
  ],
  inventory: [
    "Aggiungi gli ingredienti con unità e costo di acquisto.",
    "Aggiorna le scorte quando ricevi la merce.",
    "Imposta la scorta minima per ricevere avvisi di riordino.",
    "Collega gli ingredienti alle ricette per lo scarico automatico.",
    "Usa la ricerca e le categorie per trovare subito un articolo.",
  ],
  inventario: [
    "Apri l'inventario periodico per contare le scorte reali.",
    "Inserisci le quantità contate per ogni articolo.",
    "Confronta il conteggio con le scorte teoriche.",
    "Conferma per allineare il magazzino.",
    "Stampa il report dell'inventario.",
  ],
  catalog: [
    "Gestisci i prodotti in vendita con foto e prezzi.",
    "Attiva o disattiva la visibilità di ogni prodotto nei portali.",
    "Modifica prezzo dettaglio, ingrosso e azienda.",
    "Organizza i prodotti per categorie.",
    "Usa la ricerca per trovare un prodotto al volo.",
  ],
  listino: [
    "Crea listini personalizzati per gruppi di clienti.",
    "Imposta sconti percentuali o prezzi netti per prodotto.",
    "Assegna il listino al cliente dalla sua scheda.",
    "Controlla l'anteprima dei prezzi come li vede il cliente.",
    "Aggiorna i prezzi quando cambiano i costi.",
  ],
  foodcost: [
    "Apri il food cost per vedere costo e margine di ogni ricetta.",
    "Il costo si calcola dagli ingredienti del ricettario.",
    "Confronta costo e prezzo di vendita per trovare i margini bassi.",
    "Aggiorna i costi di acquisto per avere margini reali.",
    "Usa la ricerca per analizzare un prodotto specifico.",
  ],
  acquistati: [
    "Registra i prodotti acquistati e rivenduti (non prodotti da te).",
    "Imposta costo di acquisto e prezzo di vendita.",
    "Controlla il margine calcolato automaticamente.",
    "Collega il fornitore per il riordino veloce.",
    "Usa la ricerca per trovare un articolo.",
  ],
  eventi: [
    "Crea una giornata speciale (Natale, Pasqua, eventi).",
    "Aggiungi i prodotti dedicati con i prezzi dell'evento.",
    "Raccogli le prenotazioni dei clienti per l'evento.",
    "Controlla i totali da produrre per la giornata.",
    "Chiudi l'evento quando è concluso.",
  ],
  reorder: [
    "Controlla i prodotti sotto scorta minima suggeriti per il riordino.",
    "Scegli il fornitore per ogni articolo.",
    "Invia la richiesta di riordino al fornitore con un tocco.",
    "Segna la merce ricevuta per aggiornare il magazzino.",
    "Modifica le quantità prima dell'invio.",
  ],
  shifts: [
    "Crea i turni della settimana per ogni dipendente.",
    "Trascina o modifica gli orari rapidamente.",
    "Pubblica i turni: i dipendenti li vedono dal loro accesso.",
    "Controlla le ore totali per dipendente.",
    "Copia la settimana precedente per fare prima.",
  ],
  azienda: [
    "Compila i dati aziendali e fiscali: appaiono su bolle e fatture.",
    "Carica il logo per personalizzare documenti e app.",
    "Gestisci gli accessi del team e i codici dei dipendenti.",
    "Configura le regole fiscali del tuo paese (IVA, campi fattura, allergeni).",
    "Attiva i backup e consulta lo storico attività.",
    "Gestisci chiusure, notifiche e integrazioni.",
  ],
  attendance: [
    "Controlla le presenze timbrate dai dipendenti.",
    "Apri il dettaglio del giorno per entrate e uscite.",
    "Correggi una timbratura errata se necessario.",
    "Esporta le ore per la busta paga.",
    "Filtra per dipendente o periodo.",
  ],
  invoices: [
    "Carica la fattura del fornitore in foto o PDF.",
    "L'AI estrae prodotti e prezzi in automatico.",
    "Controlla e conferma le righe estratte.",
    "I costi di acquisto si aggiornano da soli.",
    "Consulta lo storico fatture per fornitore.",
  ],
  staff: [
    "Aggiungi i dipendenti con ruolo e reparto.",
    "Genera il PIN per la timbratura presenze.",
    "Invita il dipendente per l'accesso al portale.",
    "Imposta cosa può vedere: i prezzi restano coperti di default.",
    "Genera buste paga e contratti dalla scheda.",
  ],
  documents: [
    "Qui trovi bolle, DDT e fatture emesse.",
    "Apri un documento per stamparlo o condividerlo.",
    "Raggruppa più bolle in un'unica fattura riepilogativa.",
    "Usa i filtri per cliente e periodo.",
    "Scarica o invia il documento via email.",
  ],
  pastdocs: [
    "Consulta lo storico di bolle e documenti passati.",
    "Filtra per anno, mese e giorno con i gruppi a scomparsa.",
    "Apri un documento per ristamparlo.",
    "Usa la ricerca per trovare un documento specifico.",
    "Controlla anche le caldane passate dal filtro dedicato.",
  ],
  payments: [
    "Controlla lo scadenzario dei pagamenti dei clienti.",
    "Segna una fattura come pagata quando incassi.",
    "Filtra per cliente o per stato di pagamento.",
    "Invia il promemoria di pagamento al cliente.",
    "Controlla il totale da incassare.",
  ],
  stats: [
    "Guarda le statistiche live di vendite e ordini.",
    "Confronta i periodi per capire l'andamento.",
    "Analizza i prodotti più venduti.",
    "Controlla gli incassi per reparto.",
    "Esporta i dati quando servono al commercialista.",
  ],
  reports: [
    "Genera report di vendite, produzione e magazzino.",
    "Scegli il periodo da analizzare.",
    "Stampa o esporta il report in CSV.",
    "Confronta i mesi per individuare le tendenze.",
    "Condividi il report con il commercialista.",
  ],
  billing: [
    "Controlla il tuo piano e la scadenza dell'abbonamento.",
    "Aggiorna il metodo di pagamento in sicurezza.",
    "Scarica le ricevute dei pagamenti.",
    "Cambia piano quando le esigenze crescono.",
    "Contatta l'assistenza da qui se qualcosa non torna.",
  ],
  trash: [
    "Qui trovi tutto quello che è stato eliminato.",
    "Usa la ricerca per trovare un elemento cancellato.",
    "Ripristina un elemento con un tocco.",
    "Svuota il cestino per eliminare definitivamente.",
    "Controlla chi ha eliminato cosa e quando.",
  ],
  foto: [
    "Carica le foto dei tuoi prodotti nella galleria.",
    "Usa la ricerca per trovare una foto.",
    "Assegna le foto a ricette e prodotti del catalogo.",
    "Elimina le foto che non servono più.",
    "Le foto appaiono nei portali clienti e nei cataloghi.",
  ],
  portal_customer: [
    "Benvenuto nel tuo portale: qui ordini e comunichi con il tuo fornitore.",
    "Scegli la scheda del reparto (panificazione, pasticceria, panettoni).",
    "Tocca i prodotti per aggiungerli all'ordine e imposta le quantità.",
    "Invia l'ordine: arriva subito al laboratorio.",
    "Compila il foglio avanzi della sera: solo la quantità avanzata.",
    "Usa i messaggi per comunicare direttamente con l'azienda.",
    "Controlla i tuoi documenti e gli ordini passati in basso.",
  ],
  portal_supplier: [
    "Benvenuto nel portale fornitori: qui ricevi le richieste di riordino.",
    "Controlla le richieste in arrivo e confermale.",
    "Comunica con l'azienda tramite i messaggi.",
    "Carica listini o documenti quando richiesto.",
    "Controlla lo storico delle forniture.",
  ],
  staff_clock: [
    "Inserisci il tuo PIN personale sul tastierino.",
    "Tocca Entrata quando inizi il turno.",
    "Tocca Uscita quando finisci.",
    "Controlla il messaggio di conferma dopo ogni timbratura.",
    "Se il PIN non funziona, chiedi al titolare di verificarlo.",
  ],
};

export const GUIDES_EN = {
  dashboard: [
    "Open the Dashboard to see today's orders, production and takings at a glance.",
    "Tap a summary card to jump to the matching section.",
    "Use the global search at the top to instantly find products, customers or pages.",
    "Check the alerts and red numbers: they show what needs attention today.",
    "Open the side menu to reach every Chef Control section.",
  ],
  cassa: [
    "Tap catalog products to add them to the receipt.",
    "Fix quantities by tapping the line in the receipt.",
    "Press Charge and choose cash or card to close the bill.",
    "Use End of day to count the till and close the shift.",
    "Review the daily totals to verify takings.",
    "Manage quick products from the POS product manager.",
  ],
  prenotazioni: [
    "Create a new reservation with name, date and number of guests.",
    "Pick the table and time to avoid overlaps.",
    "Confirm or cancel a reservation by tapping it in the list.",
    "Use the calendar to move between days.",
    "Print or share the QR so customers can book by themselves.",
  ],
  orders: [
    "Check pending orders and tap Approve to confirm them.",
    "Filter by department (pastry, bakery, panettoni) with the top filters.",
    "Open an order to see products, quantities and customer notes.",
    "Mark Fulfilled when the order is ready and delivered.",
    "Print the delivery note or invoice straight from the order.",
    "Use the search bar to find an order by customer or product.",
    "Days are grouped and collapsible: tap the date to open them.",
  ],
  production: [
    "Open Production to see what to prepare today, department by department.",
    "Tap a product to see which customers ordered it.",
    "Print the production sheet for the lab.",
    "Use the calendar to prepare upcoming days in advance.",
    "Tick completed lines to track progress.",
  ],
  partners: [
    "Add a customer with name, contacts and fiscal data.",
    "Open the customer card for dedicated price list, discounts and net prices.",
    "Generate the portal code and send it so the customer can order alone.",
    "Review the customer's orders, documents and leftovers from their card.",
    "Use the search to find a customer instantly.",
  ],
  suppliers: [
    "Add a supplier with name and contacts.",
    "Generate the supplier portal code to send requests and messages.",
    "Send reorder requests straight from the supplier card.",
    "Upload supplier invoices to update purchase costs.",
    "Check the purchase history to compare prices.",
  ],
  caldane: [
    "Create a caldana with fixed products and weekdays.",
    "Share the caldane code with the shop for confirmation.",
    "Check today's generated caldane in the dedicated list.",
    "Edit quantities or products at any time.",
    "Delivery notes are generated automatically on the chosen days.",
  ],
  ricorrenti: [
    "Create a recurring order choosing customer, products and weekdays.",
    "The order is generated automatically on set days and lands in Orders.",
    "Use Send to orders to generate today's note right away.",
    "Mixed orders are split automatically between pastry and bakery.",
    "Pause or delete a recurring order when no longer needed.",
  ],
  torte: [
    "Create a cake order with customer, delivery date and details.",
    "Choose filling, shape, size and the writing on the cake.",
    "Add accessories like candles or decorations.",
    "Print the cake card with allergens to deliver with the cake.",
    "Check the cake calendar to organize production.",
  ],
  panettoni: [
    "Add panettoni to the catalog with name, price and photo.",
    "Customers see the Panettoni tab in their portal and order from there.",
    "Orders arrive on this page: approve them and mark them fulfilled.",
    "Use the search to find a panettone in the catalog.",
    "Set the dedicated ringtone to know instantly when an order arrives.",
  ],
  avanzi: [
    "Open the daily leftovers sheet for each customer or department.",
    "Purchases fill in automatically from the day's orders.",
    "The customer only fills in the leftover quantity on each line.",
    "Use the calendar to fill in or fix past days.",
    "Leftover value flows automatically into the waste register.",
  ],
  waste: [
    "Record a waste entry choosing product, quantity and reason.",
    "Check the total loss: direct waste plus customer leftovers.",
    "Open the month-by-month summary to see where to cut.",
    "Use the search to find a recorded waste entry.",
    "Delete a wrong line with the trash icon.",
  ],
  preventivi: [
    "Create a quote choosing customer and products from the catalog.",
    "Set the agreed price: it overrides the price list.",
    "Share the quote with the customer for confirmation.",
    "Convert the quote into an order with one tap.",
    "Switch between wholesale and retail lists to recalculate prices.",
  ],
  b2b: [
    "Generate your B2B link code from this page.",
    "Enter the other business's code to connect.",
    "Approve the link request to create the channel.",
    "Send orders to the linked business right from here.",
    "Received orders appear mirrored in both businesses.",
  ],
  messages: [
    "Pick a customer or supplier to open the conversation.",
    "Write the message and send: it reaches their portal.",
    "Attach photos or documents when needed.",
    "Replies arrive here with the sound alert if enabled.",
    "Use the search to find a conversation again.",
  ],
  recipes: [
    "Create a recipe with name, category and department.",
    "Add the photo from the camera or the Chef Control gallery.",
    "Set the selling price and catalog visibility.",
    "Flag the allergens: they'll be printed on notes and cards.",
    "Open the recipe to edit or archive it.",
  ],
  formula: [
    "Open a recipe book entry to see ingredients and percentages.",
    "Unlock the padlock to edit weights and ingredients.",
    "Set pieces and weight: all doses recalculate automatically.",
    "Use sections (sourdough, doughs, glaze) for large leavened products.",
    "Link ingredients to the stock to deduct supplies when producing.",
    "Print the worksheet for the lab.",
  ],
  lab: [
    "Open the Lab to plan today's productions.",
    "Choose the recipe and the pieces to produce.",
    "Confirm production to deduct ingredients from stock.",
    "Print labels with lot and expiry date.",
    "Check the production history for traceability.",
  ],
  inventory: [
    "Add ingredients with unit and purchase cost.",
    "Update stock when goods arrive.",
    "Set the minimum stock to get reorder alerts.",
    "Link ingredients to recipes for automatic deduction.",
    "Use search and categories to find an item instantly.",
  ],
  inventario: [
    "Open the periodic inventory to count real stock.",
    "Enter the counted quantities for each item.",
    "Compare the count with theoretical stock.",
    "Confirm to align the warehouse.",
    "Print the inventory report.",
  ],
  catalog: [
    "Manage products on sale with photos and prices.",
    "Toggle each product's visibility in the portals.",
    "Edit retail, wholesale and company prices.",
    "Organize products by category.",
    "Use the search to find a product on the fly.",
  ],
  listino: [
    "Create custom price lists for groups of customers.",
    "Set percentage discounts or net prices per product.",
    "Assign the price list to the customer from their card.",
    "Preview the prices as the customer will see them.",
    "Update prices when costs change.",
  ],
  foodcost: [
    "Open food cost to see cost and margin of each recipe.",
    "The cost is computed from the recipe book ingredients.",
    "Compare cost and selling price to spot low margins.",
    "Update purchase costs to get real margins.",
    "Use the search to analyze a specific product.",
  ],
  acquistati: [
    "Record products bought and resold (not made by you).",
    "Set purchase cost and selling price.",
    "Check the automatically computed margin.",
    "Link the supplier for quick reordering.",
    "Use the search to find an item.",
  ],
  eventi: [
    "Create a special day (Christmas, Easter, events).",
    "Add the dedicated products with event prices.",
    "Collect customer bookings for the event.",
    "Check the totals to produce for the day.",
    "Close the event once it's over.",
  ],
  reorder: [
    "Check products below minimum stock suggested for reorder.",
    "Pick the supplier for each item.",
    "Send the reorder request to the supplier with one tap.",
    "Mark goods received to update the warehouse.",
    "Adjust quantities before sending.",
  ],
  shifts: [
    "Create the weekly shifts for each employee.",
    "Drag or edit the hours quickly.",
    "Publish the shifts: employees see them from their access.",
    "Check total hours per employee.",
    "Copy the previous week to go faster.",
  ],
  azienda: [
    "Fill in company and fiscal data: they appear on notes and invoices.",
    "Upload the logo to personalize documents and the app.",
    "Manage team access and employee codes.",
    "Configure your country's tax rules (VAT, invoice fields, allergens).",
    "Enable backups and review the activity log.",
    "Manage closures, notifications and integrations.",
  ],
  attendance: [
    "Review the attendance clocked by employees.",
    "Open the day detail for check-ins and check-outs.",
    "Fix a wrong punch if needed.",
    "Export the hours for payroll.",
    "Filter by employee or period.",
  ],
  invoices: [
    "Upload the supplier invoice as photo or PDF.",
    "AI extracts products and prices automatically.",
    "Review and confirm the extracted lines.",
    "Purchase costs update by themselves.",
    "Browse the invoice history by supplier.",
  ],
  staff: [
    "Add employees with role and department.",
    "Generate the PIN for attendance clocking.",
    "Invite the employee for portal access.",
    "Set what they can see: prices stay hidden by default.",
    "Generate payslips and contracts from the card.",
  ],
  documents: [
    "Here you find issued delivery notes, DDTs and invoices.",
    "Open a document to print or share it.",
    "Group several notes into a single summary invoice.",
    "Use the filters for customer and period.",
    "Download or email the document.",
  ],
  pastdocs: [
    "Browse the history of past notes and documents.",
    "Filter by year, month and day with collapsible groups.",
    "Open a document to reprint it.",
    "Use the search to find a specific document.",
    "Check past caldane too with the dedicated filter.",
  ],
  payments: [
    "Check the customers' payment schedule.",
    "Mark an invoice as paid when you collect.",
    "Filter by customer or payment status.",
    "Send a payment reminder to the customer.",
    "Check the total still to collect.",
  ],
  stats: [
    "Watch live stats of sales and orders.",
    "Compare periods to understand the trend.",
    "Analyze the best-selling products.",
    "Check takings by department.",
    "Export the data when your accountant needs it.",
  ],
  reports: [
    "Generate reports on sales, production and stock.",
    "Choose the period to analyze.",
    "Print or export the report as CSV.",
    "Compare months to spot trends.",
    "Share the report with your accountant.",
  ],
  billing: [
    "Check your plan and subscription expiry.",
    "Update the payment method securely.",
    "Download the payment receipts.",
    "Change plan as your needs grow.",
    "Contact support from here if something's off.",
  ],
  trash: [
    "Here you find everything that was deleted.",
    "Use the search to find a deleted item.",
    "Restore an item with one tap.",
    "Empty the trash to delete permanently.",
    "See who deleted what and when.",
  ],
  foto: [
    "Upload your product photos to the gallery.",
    "Use the search to find a photo.",
    "Assign photos to recipes and catalog products.",
    "Delete photos you no longer need.",
    "Photos show up in customer portals and catalogs.",
  ],
  portal_customer: [
    "Welcome to your portal: order and communicate with your supplier here.",
    "Pick the department tab (bakery, pastry, panettoni).",
    "Tap products to add them to the order and set quantities.",
    "Send the order: it reaches the lab immediately.",
    "Fill in the evening leftovers sheet: only the leftover quantity.",
    "Use messages to talk directly with the business.",
    "Check your documents and past orders at the bottom.",
  ],
  portal_supplier: [
    "Welcome to the supplier portal: reorder requests arrive here.",
    "Check incoming requests and confirm them.",
    "Communicate with the business through messages.",
    "Upload price lists or documents when requested.",
    "Review the supply history.",
  ],
  staff_clock: [
    "Enter your personal PIN on the keypad.",
    "Tap Check-in when your shift starts.",
    "Tap Check-out when you finish.",
    "Check the confirmation message after each punch.",
    "If the PIN doesn't work, ask the owner to verify it.",
  ],
};
